<template>
  <div ref="Whole_page">
    <vx-card class="mb-3">
      <div class="vx-row">
        <div class="vx-col xs:w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
          <label>Module</label>
          <v-select ref="moduleDropdown" class="w-full mb-3" placeholder="Search / Select Module" :options="modules" @input="init" @search:focus="init" v-model="selectedModule" ></v-select>
        </div>
        <div class="self-center vx-col xs:w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
            <label>Search Options</label>
            <div class="mb-4 info-next-to-checkcss vx-row">
              <div>
                <vs-checkbox class="mr-3" v-model="showOnlyUnassigned" color="warning">Show Only Unassigned</vs-checkbox>
              </div>
            </div>
          </div>
          <div style="justify-content:center; display: flex;" class="self-center vx-col xs:w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
            <vs-button id="search" :disabled="!selectedModule"   vs-align="center" class="shadow" icon-pack="feather" icon="icon-search" color="success" @click="loadData">Search</vs-button>
          </div>
        </div>
    </vx-card>
    <vx-card v-if="tableHidden"  class="w-full mb-6">
      <vs-table ref="studentModuleTable" stripe class="vs-con-loading__container" single pagination :max-items="itemsPerPage" search :data="studentModules">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
          <div class="flex flex-wrap-reverse items-center">
            
          </div>
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
              <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ studentModules.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : studentModules.length }} of {{ studentModules.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=25">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=50">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=100">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="studentFullName">Student</vs-th>
          <vs-th sort-key="moduleName">Module</vs-th>
          <vs-th sort-key="assignedAssessorId">Assessors</vs-th>
          <vs-th sort-key="assignedModeratorId">Moderators</vs-th>
          <vs-th sort-key="assignedEvaluatorId">Evaluators</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="sm" :key="indextr" v-for="(sm, indextr) in data">

            <vs-td :data="data[indextr].studentFullName">
              {{ sm.studentFullName }}
            </vs-td>

            <vs-td :data="data[indextr].moduleName">
              {{ sm.moduleName }}
            </vs-td>

            <!--Assessors-->
            <vs-td v-if="sm.assignedAssessorId" :data="data[indextr].assignedAssessorId">
              <span :key="indexA" v-for="(assessor, indexA) in adminList.filter(x=>x.id == sm.assignedAssessorId && x.userRoleId == 9)" class="align-multiline-content">
                {{ assessor.name }}
                <vs-button class="ml-1" size="small" color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="unassignAssessor(sm.id, assessor.id)"></vs-button>
              </span>
            </vs-td>

            <vs-td v-else-if="!sm.assignedAssessorId" :data="data[indextr].assignedAssessorId">
              <span :key="indexA" v-for="(assessor, indexA) in adminList.filter(x=>x.userRoleId == 9)" class="align-multiline-content">
                {{ assessor.name }}
                <vs-button class="ml-1" size="small" color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assignAssessor(sm.id, assessor.id)"></vs-button>
              </span>
            </vs-td>

            <!--Moderator-->
            <vs-td v-if="sm.assignedModeratorId" :data="data[indextr].assignedModeratorId">
              <span :key="indexA" v-for="(moderator, indexA) in adminList.filter(x=>x.id == sm.assignedModeratorId && x.userRoleId == 10)" class="align-multiline-content">
                {{ moderator.name }}
                <vs-button class="ml-1" size="small" color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="unassignModerator(sm.id, moderator.id)"></vs-button>
              </span>
            </vs-td>

            <vs-td v-else-if="!sm.assignedModeratorId" :data="data[indextr].assignedModeratorId">
              <span :key="indexA" v-for="(moderator, indexA) in adminList.filter(x=>x.userRoleId == 10)" class="align-multiline-content">
                {{ moderator.name }}
                <vs-button class="ml-1" size="small" color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assignModerator(sm.id, moderator.id)"></vs-button>
              </span>
            </vs-td>

            <!--Evaluators-->
            <vs-td v-if="sm.assignedEvaluatorId" :data="data[indextr].assignedEvaluatorId">
              <span :key="indexA" v-for="(evaluator, indexA) in adminList.filter(x=>x.id == sm.assignedEvaluatorId && x.userRoleId == 13)" class="align-multiline-content">
                {{ evaluator.name }}
                <vs-button class="ml-1" size="small" color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="unassignEvaluator(sm.id, evaluator.id)"></vs-button>
              </span>
            </vs-td>

            <vs-td v-else-if="!sm.assignedEvaluatorId" :data="data[indextr].assignedEvaluatorId">
              <span :key="indexA" v-for="(evaluator, indexA) in adminList.filter(x=>x.userRoleId == 13)" class="align-multiline-content">
                {{ evaluator.name }}
                <vs-button class="ml-1" size="small" color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assignEvaluator(sm.id, evaluator.id)"></vs-button>
              </span>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

  </div>
</template>

<script>

  import vSelect from 'vue-select'

  export default {
    data() {
      return {
        showOnlyUnassigned: false,
        loadingColor:'#fff',
        itemsPerPage: 10,
        isMounted: false,
        studentModules: [],
        adminList:[],
        tableHidden:false,
        moduleDropdown:null,
        modules:[],
        selectedModule:null,
      }
    },
    components:{
      vSelect
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
        }
        return 0;
      }
    },
    methods: {
      init(){
        this.tableHidden = false;
        this.studentModules = [];
      },
      assignAssessor(smId, assessorId) {
        var self = this;
        self.showLoadingOnTable();

        var onSuccess = function () {
          self.$vs.loading.close(self.$refs.studentModuleTable.$el);
          //self.loadData();
          var index = self.studentModules.findIndex(x=> x.id == smId);
          self.studentModules[index].assignedAssessorId = assessorId;
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Assigned",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-check',
            });  
        };

        self.$ajaxGet(self, "StudentModule/AssignAssessor?id=" + smId + "&assessorId=" + assessorId, onSuccess);
      },
      unassignAssessor(smId, assessorId) {
        const self = this;
        self.showLoadingOnTable();

        var onSuccess = function () {
          self.$vs.loading.close(self.$refs.studentModuleTable.$el);
          // self.loadData();
          var index = self.studentModules.findIndex(x=> x.id == smId);
          self.studentModules[index].assignedAssessorId = null;
          self.$vs.notify({
            title:'Information',
            color: "danger",
            text: "Removed",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-check',
            });
        };

        self.$ajaxGet(self, "StudentModule/UnassignAssessor?id=" + smId + "&assessorId=" + assessorId, onSuccess);
      },
      assignModerator(smId, moderatorId) {
        const self = this;
        self.showLoadingOnTable();

        var onSuccess = function () {
          self.$vs.loading.close(self.$refs.studentModuleTable.$el);
          // self.loadData();
          var index = self.studentModules.findIndex(x=> x.id == smId);
          self.studentModules[index].assignedModeratorId = moderatorId;
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Assigned",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-check',
            });
        };

        self.$ajaxGet(self, "StudentModule/AssignModerator?id=" + smId + "&moderatorId=" + moderatorId, onSuccess);
      },
      unassignModerator(smId, moderatorId) {
        const self = this;
        self.showLoadingOnTable();

        var onSuccess = function () {
          self.$vs.loading.close(self.$refs.studentModuleTable.$el);
          // self.loadData();
          var index = self.studentModules.findIndex(x=> x.id == smId);
          self.studentModules[index].assignedModeratorId = null;
          self.$vs.notify({
            title:'Information',
            color: "danger",
            text: "Removed",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-check',
            });
        };

        self.$ajaxGet(self, "StudentModule/UnassignModerator?id=" + smId + "&moderatorId=" + moderatorId, onSuccess);
      },
      assignEvaluator(smId, evaluatorId) {
        const self = this;
        self.showLoadingOnTable();

        var onSuccess = function () {
          self.$vs.loading.close(self.$refs.studentModuleTable.$el);
          // self.loadData();
          var index = self.studentModules.findIndex(x=> x.id == smId);
          self.studentModules[index].assignedEvaluatorId = evaluatorId;
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Assigned",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-check',
            });
        };

        self.$ajaxGet(self, "StudentModule/AssignEvaluator?id=" + smId + "&evaluatorId=" + evaluatorId, onSuccess);
      },
      unassignEvaluator(smId, evaluatorId) {
        const self = this;
        self.showLoadingOnTable();

        var onSuccess = function () {
          self.$vs.loading.close(self.$refs.studentModuleTable.$el);
          // self.loadData();
          var index = self.studentModules.findIndex(x=> x.id == smId);
          self.studentModules[index].assignedEvaluatorId = null;
          self.$vs.notify({
            title:'Information',
            color: "danger",
            text: "Removed",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-check',
            });
        };

        self.$ajaxGet(self, "StudentModule/UnassignEvaluator?id=" + smId + "&evaluatorId=" + evaluatorId, onSuccess);
      },
      loadData() {
        var self = this;
        self.showLoadingOnElement("Whole_page",1,"corners");

        var onSuccess = function (response) {
          self.tableHidden = true;
          self.studentModules = response.data;
        };

        var onFinally = function () {
          self.$vs.loading.close(self.$refs.Whole_page.$el);
         
        };

        self.$ajaxGet(self, "StudentModule/ListStudentModules?showOnlyUnassigned=" + self.showOnlyUnassigned + `&moduleId=${this.selectedModule.value}`, onSuccess, onFinally);
      },
      showLoadingOnTable(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.studentModuleTable.$el,
          scale: 1
        });
      },
      showLoadingOnDeleteButton(){
        var self = this;
        self.$vs.loading({
          background: self.loadingColor,
          type: "material",
          container: self.$refs.deleteButton.$el,
          scale: 0.45
        });
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      getAssigned(){
        var self = this;
        self.showLoadingOnElement("Whole_page",1,"corners");
        var onSuccess = response =>{
          self.adminList = response.data;
        }
      
        var onFinally = response =>{
          if(self.$refs.Whole_page){
            self.$vs.loading.close(self.$refs.Whole_page.$el);
          }
        }
      
        self.$ajaxGet(self, "StudentModule/GetAdminUsers" , onSuccess, onFinally);
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      loadModules(){
        var self = this;
        self.showLoadingOnElement("moduleDropdown",1,"corners");
        var onSuccess = response =>{
          self.modules = response.data.map((item) => {return {label: item.text, value: item.value} });
        }
      
        var onFinally = response =>{
          if(self.$refs.moduleDropdown){
            self.$vs.loading.close(self.$refs.moduleDropdown.$el);
          }
        }
      
        self.$ajaxGet(self, "StudentModule/GetModules" , onSuccess, onFinally);
      },
    },
    mounted() {
      var self = this;
      //self.loadData();
      self.isMounted = true;
      self.loadModules();
      self.getAssigned();
    },
  }

</script>
<style lang="scss">
  .align-multiline-content {
    display: flex;
    align-items: center;
  }
</style>
